module.exports = __webpack_public_path__ + "img/wish-fill.f69786a.svg?v=1764903765445";